module.exports = __webpack_public_path__ + "static/img/new_top.4ab26ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/new_top.png
// module id = VnQf
// module chunks = 1